<div ngbDropdown placement="bottom-right" class="language-switcher" autoClose="true">
  <div ngbDropdownToggle class="toggler">
    <span class="" [ngClass]="{ 'header_topbar-icon--brand' : iconType === 'brand' }">
      <img class="" src="{{language?.flag}}" alt="" />
    </span>
  </div>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
    class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
    <ul class="">
      <ng-container *ngFor="let language of languages">
        <li ngbDropdownItem class="" [ngClass]="{'item-active': language.active}">
          <a href="javascript:;" (click)="setLanguage(language.lang)" [ngClass]="{'lang-active': language.active}"
            class="">
            <span class="">
              <img src="{{language.flag}}">
            </span>
            <span class="">{{language.name}}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
